import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden md:h-[640px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20anime%20manga%20illustration%20of%20floating%20open%20comic%20books%20and%20dynamic%20action%20panels%20in%20warm%20coral%20and%20golden%20amber%20tone%2C%20abstract%20artistic%20comic%20collage%20with%20paper%20texture%2C%20energetic%20young%20vibrant%20atmosphere%2C%20dark%20moody%20edges&width=1800&height=1000&seq=hero-manga-bg&orientation=landscape"
          alt="长期连载漫画库背景插画"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl px-4 py-16 text-center md:px-6 md:py-24">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/40 bg-black/25 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm md:text-sm">
          <i className="ri-flashlight-line text-accent-300"></i>
          追更神器 · 稳定连载
        </span>
        <h1 className="mt-6 font-heading text-3xl leading-tight text-background-50 md:text-5xl lg:text-6xl">
          长期连载漫画库
          <br />
          <span className="text-accent-300">稳定更新不断更</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          长篇神作、持续连载精品一网打尽。告别追更焦虑，点开即享稳定连载体验——天天漫画网，陪你追更每一天。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/series"
            className="w-full whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            立即开启追更
          </Link>
          <Link
            to="/about"
            className="w-full whitespace-nowrap rounded-md border border-background-50/50 bg-black/20 px-7 py-3 text-sm font-bold text-background-50 backdrop-blur-sm transition-colors hover:bg-black/30 sm:w-auto"
          >
            了解我们
          </Link>
        </div>

        <div className="mx-auto mt-10 grid w-full max-w-3xl grid-cols-3 gap-3 md:gap-4">
          {[
            { num: "500+", label: "连载作品" },
            { num: "1000+", label: "稳定更新周" },
            { num: "260w+", label: "追更读者" },
          ].map((s) => (
            <div
              key={s.label}
              className="rounded-lg border border-background-50/20 bg-black/20 px-3 py-4 text-center backdrop-blur-sm"
            >
              <p className="font-heading text-xl text-accent-300 md:text-2xl">{s.num}</p>
              <p className="mt-1 text-xs text-background-100 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}